/**
 * Action and mutation types for wordpress/themes module
 */
const types = {
  FETCH: 'fetch',
  UPDATE: 'update'
}

export default types



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/themes/types.js